export const storeBookingFeeTypeList = (state, bookingFeeTypeList) => {
  state.bookingFeeTypeList = [...bookingFeeTypeList];
};
